<div class="flex flex-col w-full">
    <img [src]="imageURL" alt="image" style="max-height: 80vh;">
    <button type="button"
            mat-raised-button
            color="warn"
            (click)="close()">
        Close
    </button>
</div>
